import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import './TaskLog.css'

const TaskLogUI = ({context, messageList, project, taskLog, projectUserMap,
    deleteMode, onDeleteClick, onDeleteCancel, onDeleteSubmit, deleteSubmitted
  }) =>
  <div className='c_tsk_log'>
    <div className='g_flex_h'>
      <AvatarUI taskLog={taskLog} projectUserMap={projectUserMap} />
      <CenterUI
        messageList={messageList}
        taskLog={taskLog}
        projectUserMap={projectUserMap}
        deleteMode={deleteMode}
      />
      {
        project.permissionList.includes('prj_participate') &&
        <div className='icon icon-trash-o g_link_2' onClick={onDeleteClick} />
      }
    </div>

    {
      deleteMode &&
      <div className='action g_flex_h'>
        <ButtonUI
          messageList={messageList}
          labelKey='c_cancel'
          transparent={true}
          onClick={onDeleteCancel}
        />
        <SpinnerUI show={deleteSubmitted} />
        <ButtonUI
          messageList={messageList}
          labelKey='c_delete'
          onClick={onDeleteSubmit}
          disabled={deleteSubmitted}
        />
      </div>
    }
  </div>

const AvatarUI = ({taskLog, projectUserMap}) =>
  <React.Fragment>
    {
      !taskLog.createdByUserLeft &&
      <img className='avatar' alt=''
        src={projectUserMap[taskLog.createdByUserId] &&
          projectUserMap[taskLog.createdByUserId]['avatarUrl']
        }
      />
    }
    {
      taskLog.createdByUserLeft &&
      <div className='icon icon-user' />
    }
  </React.Fragment>

const CenterUI = ({messageList, taskLog, projectUserMap}) =>
  <div className='center'>
    {
      !taskLog.createdByUserLeft &&
      <span className='name'>
        {taskLog.createdByUserName}
      </span>
    }
    {
      taskLog.createdByUserLeft &&
      <span className='name'>
        <s>{taskLog.createdByUserName}</s>
      </span>
    }
    <span className='g_muted g_small'>
      {taskLog.dateCreatedStr}
    </span>
    <div className='log'>
      {
        taskLog.oldValue &&
        <span>{taskLog.oldValue}</span>
      }
      {
        !taskLog.oldValue &&
        <MessageUI messageList={messageList} messageKey='c_none' />
      }
      <span className='icon icon-angle-double-right' />
      {
        taskLog.newValue &&
        <span>{taskLog.newValue}</span>
      }
      {
        !taskLog.newValue &&
        <MessageUI messageList={messageList} messageKey='c_none' />
      }
    </div>
  </div>

export default TaskLogUI
